var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.8458 10.0328L18.3327 17.4869L17.5517 18.3334L9.99935 10.8137L2.51244 18.3334L1.66602 17.4869L9.15292 10.0328L1.66602 2.51312L2.51244 1.66669L9.99935 9.18633L17.5517 1.66669L18.3327 2.51312L10.8458 10.0328Z",
  fill: "white"
})));
export default SvgClose;